import React from 'react';
import withTheme from '@material-ui/core/styles/withTheme';
import SvgIcon from '@material-ui/core/SvgIcon';

function Category(props) {
    const theme = props.theme;

    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <g id="CategoryIcon">
                <path fill={theme.palette.primary.main} d="M12 2l-5.5 9h11z"></path>
                <circle fill={theme.palette.secondary.main} cx="17.5" cy="17.5" r="4.5"></circle>
                <path fill={theme.palette.secondary.dark} d="M3 13.5h8v8H3z"></path>                
            </g>
        </SvgIcon>
    );
}

export default withTheme(Category);